function shortenLength(string: string, length: number = 5) {
  return string?.substring(0, length);
}

function addEllipsis(string: string) {
  return `${string}...`;
}

export { addEllipsis, shortenLength };
